import React from 'react';
import Icon from '../../components/Icon/Icon';

const getTrackTitle = (track, idx) =>
    track?.title || track?.file_name || track?.media_url?.split('/').pop() || `Track ${idx + 1}`;

// HYK-914 / HYK-1139: multi-track music tracklist. Styles live in ViewCreation.scss (.hyk914-track-card).
const TrackList = ({ tracks, selectedIndex, onSelectTrack }) => (
    <div className="hyk914-track-card__tracklist hyk914-track-card__tracklist--solo">
        {tracks.map((track, idx) => {
            const title = getTrackTitle(track, idx);
            const isActive = idx === selectedIndex;
            return (
                <button
                    key={track?.media_id || idx}
                    type="button"
                    onClick={() => onSelectTrack(idx)}
                    className={`hyk914-track-card__track-row ${isActive ? 'is-active' : ''}`}
                    aria-label={`Play ${title}`}
                    aria-current={isActive ? 'true' : undefined}
                >
                    <span className="hyk914-track-card__track-title">
                        {idx + 1}. {title}
                    </span>
                    {isActive ? (
                        <span className="hyk914-track-card__playing" aria-hidden="true">
                            <Icon alias="hyk914_playing_equalizer" width={20} color="none" />
                        </span>
                    ) : null}
                </button>
            );
        })}
    </div>
);

export default TrackList;
